import { AzureOfferPlan } from '../../../../modules/privateOffer/reducer'

import { useStyles as usePricingStyles } from '../Sections.styles'
import {
  DetailInfo,
  DetailRow,
} from '../../../../common/components/DetailRow/DetailRow'
import { Truncate } from '@labrav/react-components'
import { useStyles } from './PlanBasicDetail.styles'
import { DisplayValueData } from '../../../PrivateOfferFormV2/AzureOffer/Plan/PlanRow/MeteringDimensions/MeteringDimensions'
import {
  Product,
  ProductPlan,
} from '../../../../modules/productsListing/reducer'

interface PlanBasicDetailProps {
  plan: AzureOfferPlan
  product: Product
}

export const PlanBasicDetail = ({ plan, product }: PlanBasicDetailProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()
  const selectedProductPlan = product?.plans?.find(
    planItem => planItem?.planId === plan?.labraPlanId
  ) as ProductPlan

  const publicPlanPrice =
    selectedProductPlan?.pricing?.[0]?.pricePerPaymentInUsd
  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Plan details</div>
      <DetailRow className={classes.planDetailRow} props={{ spacing: 4 }}>
        <>
          <DetailInfo
            title="Plan"
            value={
              <Truncate width={'100%'} clipboardTooltip showIcon={false}>
                {plan.displayName}
              </Truncate>
            }
            keyName="displayName"
            gridSize={4}
          />
          <DetailInfo
            title="Description"
            value={
              <Truncate width={'100%'} clipboardTooltip showIcon={false}>
                {plan.description}
              </Truncate>
            }
            keyName="description"
            gridSize={6}
          />
          <DetailInfo
            title="Public price"
            value={
              <DisplayValueData
                isPrice
                id="publicPrice"
                value={publicPlanPrice || 0}
                precision={5}
              />
            }
            keyName="publicPrice"
            gridSize={2}
            align="end"
          />
        </>
      </DetailRow>
    </div>
  )
}
